import React from 'react';
import { PurchaseLot } from '../../../../../../types/entities.js';
import styles from './LotTitle.module.scss';

interface Props {
  lot: PurchaseLot;
}

const LotTitle: React.FC<Props> = ({ lot }) => {
  const isCanceled = lot.status.name === 'canceled';

  return (
    <summary className={styles.title}>
      {isCanceled ? (
        <>
          <s>Лот {lot.number}</s>
          <div className={styles.canceledLabel}>Отменен</div>
        </>
      ) : (
        <>Лот {lot.number}</>
      )}
    </summary>
  );
};

export default React.memo(LotTitle);
